import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import type { StreamableBlockAttsInterface } from '~/types/AppData/Blocks/StreamableBlockInterface';
import Embed from '~/components/Shared/Embeds/Embed';

export default component$(
  ({ html, height }: StreamableBlockAttsInterface): JSX.Element => {
    return (
      <Embed embed={html} type='iframe' style={{ height: `${height}px` }} />
    );
  }
);
